import { render } from "./QuickMenu.vue?vue&type=template&id=1f2a1992"
import script from "./QuickMenu.vue?vue&type=script&lang=js"
export * from "./QuickMenu.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__